import { apiFetch } from '@/lib/api';
import { cachedFetch, invalidate, SHELL_CACHE_TTL_MS } from '@/lib/requestCache';

export type Vertical = 'services' | 'products';
export type Language = 'pt-BR' | 'pt-PT';

export interface TenantProfile {
  business_name: string;
  owner_name: string;
  language: Language;
  vertical: Vertical | null;
  working_hours_json: Record<string, unknown> | null;
  knowledge_md: string;
}

export interface TenantProfileUpdateRequest {
  business_name?: string;
  owner_name?: string;
  language?: Language;
  vertical?: Vertical;
}

export const tenantProfileService = {
  /** F070: cached (30s TTL). */
  get(opts?: { fresh?: boolean }): Promise<TenantProfile> {
    return cachedFetch('tenant:profile', () => apiFetch<TenantProfile>('/tenant/profile'), {
      ttlMs: SHELL_CACHE_TTL_MS,
      fresh: opts?.fresh,
    });
  },
  async update(payload: TenantProfileUpdateRequest): Promise<TenantProfile> {
    const next = await apiFetch<TenantProfile>('/tenant/profile', {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
    invalidate('tenant:profile');
    return next;
  },
};
